/**
 * Entity avatar upload via dash-api.
 * POST /api/entities/{entityId}/avatar (multipart field: file) → { imageUrl }
 */

import {getAwpClientHeaders} from '../../session/awpRequestHeaders';

const AWP_BASE = (process.env.REACT_APP_AWP_API_BASE || process.env.REACT_APP_AWP_API_URL || '')
    .replace(/\/$/, '');

/**
 * Upload an entity portrait image.
 *
 * @param {string} entityId - KB entity id (Q-id or D… ref)
 * @param {File|Blob} file
 * @returns {Promise<{imageUrl: string}>}
 */
export async function uploadEntityAvatar(entityId, file) {
    if (!entityId) throw new Error('entityId is required');
    if (!file) throw new Error('file is required');

    const form = new FormData();
    form.append('file', file);

    const res = await fetch(
        `${AWP_BASE}/api/entities/${encodeURIComponent(entityId)}/avatar`,
        {
            method: 'POST',
            headers: {
                ...getAwpClientHeaders(),
            },
            body: form,
        },
    );

    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message || err.error || `HTTP ${res.status}`);
    }

    const data = await res.json();
    if (!data?.imageUrl || typeof data.imageUrl !== 'string') {
        throw new Error('Avatar upload did not return imageUrl.');
    }
    return data;
}
